import React from "react";
import { makeStyles } from "@mui/styles";
import Icon from "@mui/material/Icon";
import clsx from "clsx";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Switch,
  Radio,
} from "@mui/material";
import CustomTextField from "../../common/TextField";

const useStyles = makeStyles(theme => ({
  table: {},
  th: {
    borderBottom: "1px solid #f1f1f1",
    fontSize: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    paddingTop: 5,
    paddingBottom: 5,
    lineHeight: "normal",
    "& span": {
      float: "right",
    },
  },
  td: {
    borderBottom: "1px solid #f1f1f1",
    fontSize: 12,
    padding: 8,
    "& .MuiInputBase-root": {
      marginTop: "0 !important",
    },
  },
  tdCb: {
    padding: "4px 0",
    paddingRight: "0 !important",
    minWidth: 18,
    "& .MuiCheckbox-root": {
      padding: 0,
      paddingBottom: 2,
    },
    "& .MuiSvgIcon-root": {
      width: "18px !important",
      height: "18px !important",
    },
  },
  iconButtonDelete: {
    padding: 4,
    color: theme.palette.common.red,
    marginLeft: 5,
  },
  icon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 14,
  },
  addLink: {
    fontSize: 12,
    color: theme.palette.primary.main,
    marginTop: 10,
    padding: 0,
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      opacity: 0.8,
    },
  },
  addIcon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 12,
    marginRight: 8,
    marginTop: 3,
  },
}));

const VATRatesTable = () => {
  const classes = useStyles();

  return (
    <>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.th}>name</TableCell>
            <TableCell className={classes.th}>
              vat rate <span>%</span>
            </TableCell>
            <TableCell className={classes.th} align="center">
              Standard VAT rate
            </TableCell>
            <TableCell className={classes.th} align="center">
              Active
            </TableCell>
            <TableCell className={classes.th} />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={classes.td}>
              <CustomTextField />
            </TableCell>
            <TableCell className={classes.td}>
              <CustomTextField />
            </TableCell>
            <TableCell className={classes.tdCb} align="center">
              <Radio />
            </TableCell>
            <TableCell className={classes.td} align="center">
              <Switch name="checkedB" color="primary" size="small" />
            </TableCell>
            <TableCell className={classes.td}>
              <IconButton className={classes.iconButtonDelete}>
                <Icon className={clsx(["fa fa-times", classes.icon])} />
              </IconButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Button className={classes.addLink}>
        <Icon className={clsx(["fas fa-plus", classes.addIcon])} />
        Add row
      </Button>
    </>
  );
};

export default VATRatesTable;
